module.exports = __webpack_public_path__ + "assets/images/profiles/1970-2.jpg?v=893670b5";